/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/prefer-default-export */
import React, { useEffect, useState, useMemo } from 'react'
import clsx from 'clsx'
import s from './Collections.module.css'

import { CollectionsCard } from './components/CollectionCard'
import { CreateCollection } from './components/CollectionCard/components/CreateCollection'

export function Collections({ withCreateButton = false, allCollectionsUrl, agentId, signedIn, isOwner, archived, showCreateModal }) {  
  const [collections, setCollections] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [showArchive, setShowArchive] = useState(!!archived)

  const [showCreateCollection, setShowCreateCollection] = useState(!!showCreateModal)

  async function fetchCollections() {
    try {
      setIsLoading(true)
      const apiToken = localStorage.getItem('apiToken')
      const params = new URLSearchParams({
        agent_id: agentId,
      })

      const response = await fetch(`/api/v3/listing_collections${agentId ? `?${params}` : ''}`, {
        headers: {
          'API_TOKEN': apiToken,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })

      const data = await response.json()

      setCollections(data)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchCollections()
  }, [])

  const filteredCollections = useMemo(() => {
    if (showArchive) {
      return collections.filter((collection) => collection.archived)
    }
    return collections.filter((collection) => !collection.archived)
  }, [collections, showArchive])

  const collectionList = withCreateButton ? filteredCollections?.slice(0, signedIn ? 3 : 4) : filteredCollections

  const handleCreateCollection = () => setShowCreateCollection(true)

  return (
    <>
      {withCreateButton && (
        <a href={allCollectionsUrl} className={s.collectionsLink}>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16" fill="none">
            <path
              d="M11 15L6 11.875L1 15V1.25C1 1.08424 1.06585 0.925269 1.18306 0.808058C1.30027 0.690848 1.45924 0.625 1.625 0.625H10.375C10.5408 0.625 10.6997 0.690848 10.8169 0.808058C10.9342 0.925269 11 1.08424 11 1.25V15Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          All Collections {collections.length > 0 && <sup>{collections.length}</sup>}
        </a>
      )}

      {isOwner && (
        <div className={s.filter}>
          <div className={clsx(s.filterItem, !showArchive && s.active)} onClick={() => setShowArchive(false)}>
            All
          </div>
          <div className={clsx(s.filterItem, showArchive && s.active)} onClick={() => setShowArchive(true)}>
            Archived
          </div>
        </div>
      )}

      <div className={s.root}>
        {isLoading ? (
          <div className={s.loading}>Loading...</div>
        ) : collectionList.length > 0 ? (
          <>
            {collectionList.map((collection) => {
              const isOwner = collection.ownership === 'owner'

              return (
                <CollectionsCard
                  isOwner={isOwner}
                  fetchCollections={fetchCollections}
                  collection={collection}
                  key={collection.id}
                />
              )
            })}
            {withCreateButton && signedIn && isOwner && (
              <div className={s.createCard} onClick={handleCreateCollection}>
                Create a new collection
              </div>
            )}
          </>
        ) : (
          <div className={s.empty}>There are no collections yet.</div>
        )}
      </div>

      {showCreateCollection && <CreateCollection onClose={() => setShowCreateCollection(false)} />}
    </>
  )
}
